export async function sleep(time:number){
    return await (new Promise((ok) =>{
        setTimeout(ok, time);
    }));
}